import { useRef, useEffect } from 'react';
export function useIntersectionObserver(callback, options) {
    const targetRef = useRef(null);
    const observerRef = useRef(null);
    useEffect(() => {
        if (!targetRef.current)
            return void 0;
        if (observerRef.current)
            observerRef.current = null;
        observerRef.current = new IntersectionObserver((entries, observer) => {
            entries.forEach(async (entry) => {
                if (entry.intersectionRatio > 0) {
                    if (callback)
                        await callback(entries, observer);
                    observer.unobserve(entry.target);
                }
            });
        }, options);
        observerRef.current.observe(targetRef.current);
        return () => {
            if (observerRef.current)
                observerRef.current.disconnect();
        };
    }, [targetRef, callback, options]);
    return targetRef;
}
//# sourceMappingURL=useIntersectionObserver.js.map